module.exports = __webpack_public_path__ + "static/img/logo_sub.d1b04d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_sub.jpg
// module id = not/
// module chunks = 1